import React, { Dispatch, createContext, useContext, useReducer } from 'react';

// Provider (estado + dispatch) e hooks de acesso do padrão factory → Provider das telas
export function createReducerContext<S>(name: string, reducer: (state: S, action: any) => S, initialState: S) {
    const StateContext = createContext<S | undefined>(undefined);
    const DispatchContext = createContext<Dispatch<any> | undefined>(undefined);

    function Provider({ children }: { children: React.ReactNode }) {
        const [state, dispatch] = useReducer(reducer, initialState);
        return (
            <StateContext.Provider value={state}>
                <DispatchContext.Provider value={dispatch}>
                    {children}
                </DispatchContext.Provider>
            </StateContext.Provider>
        );
    }

    function useStateContext() {
        const context = useContext(StateContext);
        if (!context) throw new Error(`use${name}State must be used within ${name}Provider`);
        return context;
    }

    function useDispatchContext() {
        const context = useContext(DispatchContext);
        if (!context) throw new Error(`use${name}Dispatch must be used within ${name}Provider`);
        return context;
    }

    return { Provider, useStateContext, useDispatchContext };
}
